import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { IProduto } from '../models/produto';
import { ProdutosApi } from '../api/produtos.api';
import { IProdutoDTO } from '../dto/produto-dto';
import { Tso } from 'ts-odata';
import { ApiResultado } from '../models/api-resultado';
import { Observable } from 'rxjs';


@Injectable()
export class ProdutosService extends ServiceBase<IProduto, IProdutoDTO> {

  constructor(private api: ProdutosApi) {
    super(api);
  }

  buscaPorTabelaDePrecoodata(tabelaId: string, query: Tso): Observable<ApiResultado<IProdutoDTO>> {
    query.baseUri = `buscar/tabela-preco/${tabelaId}`;
    return this.odata(query);
  }
}